import { Button } from 'fitify-ui-onboarding/src/components/GenderFunnel/Button/Button'
import type { ChoiceValue } from 'fitify-ui-onboarding/src/components/GenderFunnel/ChoiceCard.Types'
import { ChoiceCardVertical } from 'fitify-ui-onboarding/src/components/GenderFunnel/ChoiceCardVertical/ChoiceCardVertical'
import { ScreenTitle } from 'fitify-ui-onboarding/src/components/GenderFunnel/ScreenTitle/ScreenTitle'
import { useTranslation } from 'next-i18next/pages'

import { StyledTwoColumnGrid } from 'components/GenderFunnel/ChoiceCardPage/ChoiceCardPage.Styled'
import { ChoiceContainer } from 'components/GenderFunnel/ChoiceCardPage/ChoiceContainer'
import { useChoicePage } from 'components/GenderFunnel/ChoiceCardPage/useChoicePage'
import { Layout } from 'components/GenderFunnel/Layout/Layout'
import type { FunnelDataPath } from 'types/state'

import type { ChoiceCardVerticalPageProps } from './ChoiceCardPage.Types'

export const ChoiceCardVerticalPage = <
  TValue extends ChoiceValue,
  TFunnel extends FunnelDataPath,
>({
  analyticsMapping,
  children,
  funnel,
  heading,
  isMultiChoice = false,
  onChange,
  options,
  subtitle,
  subtitleColorVariant,
  title,
  titleAlign,
  titleSize,
  value,
  variant,
}: ChoiceCardVerticalPageProps<TValue, TFunnel>) => {
  const { t } = useTranslation()

  const { handleChange, handleContinue, isValid } = useChoicePage<
    TValue,
    TFunnel
  >({
    analyticsMapping,
    funnel,
    isMultiChoice,
    onChange,
    options,
    value,
  })

  return (
    <Layout
      bottomContent={
        isMultiChoice ? (
          <Button type="button" isDisabled={!isValid} onClick={handleContinue}>
            {t('common_cta_continue')}
          </Button>
        ) : undefined
      }
      title={title}
    >
      <ScreenTitle
        align={titleAlign}
        title={heading ?? title}
        titleSize={titleSize}
        subtitle={subtitle}
        subtitleColorVariant={subtitleColorVariant}
      />
      <ChoiceContainer isMultiChoice={isMultiChoice}>
        <StyledTwoColumnGrid>
          {options.map((option) => {
            return (
              <ChoiceCardVertical<TValue>
                key={`${option.value}`}
                hasEmptyChoiceVisible={isMultiChoice}
                colorVariant={variant}
                imageProps={option.imageProps}
                isSelected={value.includes(option.value)}
                onSelect={handleChange}
                value={option.value}
                title={option.title}
              />
            )
          })}
        </StyledTwoColumnGrid>
      </ChoiceContainer>
      {typeof children === 'function' ? children({ handleChange }) : children}
    </Layout>
  )
}
